/**
 * The initial value of Symbol.species is the well-known symbol @@species
 * https://tc39.es/ecma262/#sec-symbol.species
 */
export const symbolSpecies = () => Symbol("Symbol.species");
